import "./styles.css"
import { ReactComponent as PlusIcon } from "../../../assets/svg/icons/plus.svg";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";
import TableVisualizationRow from "./TableVisualizationRow/Index";
import { Loading } from "../../Loading/Index";
import { useTranslation } from "react-i18next";

interface TableProductsProps {
  listTable: IProducts[];
  isLoading: boolean;
}

export default function TableProducts({ listTable, isLoading }: TableProductsProps) {
  const { t } = useTranslation();

  const {
    setOptionForm,
  } = useEditOnboarding();

  return (
    <>
      {listTable && listTable.length > 0 ?
        <>
          <table className="tableTaskEvaluation" style={{ minWidth: 800 }} id="tableProducts">
            <thead>
              <tr>
                <th>{t("tables.classification")}</th>
                <th>{t("tables.tradeName")}</th>
                <th>{t("tables.manufacturer")}</th>
                <th>{t("productPackaging.packaging")}</th>
                <th>{t("tables.products.creepFeeding")}</th>
                <th />
              </tr>
            </thead>

            <tbody>
              {listTable.map(product =>
                <TableVisualizationRow key={product.id} product={product} />
              )}
            </tbody>

            {isLoading && (
              <div className="tableLoadingOverlay" style={{ minWidth: 1400 }}>
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                </div>
              </div>
            )}
          </table>
        </>
        :
        isLoading
          ?
          <div className="emptyTable_container">
            <Loading visible={isLoading} />
          </div>
          :
          <div className="emptyTable_container">
            <span>{t("tableUi.registerFirstProduct")}</span>
            <div
              className="addProduct_button"
              onClick={() => {
                setOptionForm("create-products")
              }}
            >
              <PlusIcon />
              <span>{t("tableUi.registerProduct")}</span>
            </div>
          </div>
      }
    </>
  )
}
